import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { AlterarCentroCustoForm, AlterarCentroCustoSchema } from "../../../schemas/Funcionarios_lista/alterar_centro_custo";
import { zodResolver } from "@hookform/resolvers/zod";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { ModalLoading } from "../../../../../../common/components/modal_loading";

import PrimaryButton from "../../../../../../common/components/primary_button";
import FormContainer from "../../../../../../common/components/form_container";

/**
 * AlterarCentroCustoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  centroCustos: CentroCustoDropDown[],
  onClose: () => void;
  onSubmit: (form: AlterarCentroCustoForm) => void;
};

export const AlterarCentroCustoModal = ({
  open,
  saving,
  centroCustos,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<AlterarCentroCustoForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(AlterarCentroCustoSchema),
  })

  useEffect(() => {
    if (open) hookForm.reset();
  }, [
    open,
    hookForm,
  ]);

  const handleClose = useCallback(() => {
    if (!saving) onClose();
  }, [
    saving,
    onClose,
  ]);

  const handleSubmit = useCallback((form: AlterarCentroCustoForm) => {
    if (!saving) onSubmit(form);
  }, [
    saving,
    onSubmit,
  ]);

  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookForm.handleSubmit(handleSubmit),
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "40rem",
          },
        },
      }}>
      <DialogTitle>
        Alterar Centro de Custo
      </DialogTitle>

      <DialogContent>
        <FormContainer title={"Informações"} arrangement="fullRow">
          <ModalLoading loading={saving} message="Salvando...">
            <DefaultFormAutocomplete
              name='centroCusto'
              label='Centro de Custo'
              options={centroCustos}
              getOptionKey={(x) => x.id}
              getOptionLabel={(x) => x.title}
              reactHookForm={hookForm} />
          </ModalLoading>
        </FormContainer>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              <PrimaryButton
                type="submit"
                buttonColor="primary-green">
                Salvar
              </PrimaryButton>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}